// @flow
import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { Router, Route, Switch } from 'react-router-dom';
import createHistory from 'history/createBrowserHistory';

import StaticQR from './pages/StaticQR';
//新版static qr page
import StaticQR2Form from './pages/StaticQR2Form/';
import StaticQRConfirmation from './pages/StaticQRConfirmation';
import StaticQR2Preview from './pages/StaticQR2Preview';
import StaticQR2Result from './pages/StaticQR2Result';

//使用offline api下单
import OfflineApiOrder from './pages/OfflineApiOrder/StaticQR2Form/';
import OfflineApiOrderPreview from './pages/OfflineApiOrder/StaticQR2Preview/';

import ErrorPage from './pages/Error';

class Welcome extends Component {
  render() {
    return (
      <div style={{ textAlign: 'center', marginTop: '50px' }}>
        Welcome to Latipay
      </div>
    );
  }
}

const history = createHistory();

const REACT_APP_ROOT_URL = process.env.REACT_APP_ROOT_URL || '';

export default ({ store }) => {
  return (
    <Provider store={store}>
      <Router history={history}>
        <Switch>
          <Route
            path={`${REACT_APP_ROOT_URL}/:user_id(u\\d+)/:wallet_id(w\\d+)/:preset_amount?`}
            exact
            component={StaticQR}
          />

          <Route
            path={`${REACT_APP_ROOT_URL}/:organisationCode(.+-\\d+)/:shortCode`}
            exact
            component={StaticQR2Form}
          />

          <Route
            path={`${REACT_APP_ROOT_URL}/:organisationCode(.+-\\d+)/:shortCode/preview`}
            exact
            component={StaticQR2Preview}
          />
          <Route
            path={`${REACT_APP_ROOT_URL}/payid`}
            exact
            component={StaticQR2Preview}
          />
          <Route
            path={`${REACT_APP_ROOT_URL}/coin_payments`}
            exact
            component={StaticQR2Preview}
          />

          <Route
            path={`${REACT_APP_ROOT_URL}/result`}
            exact
            component={StaticQR2Result}
          />

          <Route
            path="/static_qr_confirmation"
            component={StaticQRConfirmation}
          />

          <Route
            path={`${REACT_APP_ROOT_URL}/error`}
            exact
            component={ErrorPage}
          />

          <Route
            path={`${REACT_APP_ROOT_URL}/offlineapi`}
            exact
            component={OfflineApiOrder}
          />

          <Route
            path={`${REACT_APP_ROOT_URL}/offlineapi/preview`}
            exact
            component={OfflineApiOrderPreview}
          />

          <Route path="/" exact component={Welcome} />
        </Switch>
      </Router>
    </Provider>
  );
};



// WEBPACK FOOTER //
// ./src/App.js